import {NavDropdown} from "react-bootstrap";
import {ThemeMode, useTheme} from "./ThemeContext";
import {common, format} from "../i18n";

const modes: { mode: ThemeMode, label: string, icon: string }[] = [
    { mode: 'light', label: common.theme.light, icon: 'bi-sun-fill' },
    { mode: 'dark', label: common.theme.dark, icon: 'bi-moon-stars-fill' },
    { mode: 'auto', label: common.theme.auto, icon: 'bi-circle-half' }
];

export function ThemeToggle() {
    const {mode, setMode} = useTheme();
    const current = modes.find(x => x.mode === mode);
    return (
        <NavDropdown align="end" id="theme-toggle" title={<><i className={`bi ${current?.icon}`} aria-hidden="true"></i><span className="visually-hidden">{format(common.theme.current, { mode: current?.label ?? '' })}</span></>}>
            {modes.map(x => (
                <NavDropdown.Item key={x.mode} active={x.mode === mode} aria-current={x.mode === mode || undefined} onClick={() => setMode(x.mode)}>
                    <i className={`bi ${x.icon} me-2`} aria-hidden="true"></i>{x.label}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}
